import React from 'react';
import {connect} from 'react-redux';

import AudioPlayer from 'components/AudioPlayer';

import strings from 'utils/strings';

// import './styles.scss';

import audioNo from 'assets/sounds/no/6 1 Ordforstaelse Intro.mp3';
import audioNn from 'assets/sounds/nn/6 1 Ordforstaelse Intro.mp3';
import audioNormingNo from 'assets/sounds/no/introduksjon-Ordforstaelse.mp3';
import audioNormingNn from 'assets/sounds/nn/introduksjon-Ordforstaelse.mp3';

import tutorialVideo from './assets/e845140cdea968bfb0a8144fb06a7064.mp4';

const audioObj = {
	no: audioNo,
	nn: audioNn,
};

const audioObjNorming = {
	no: audioNormingNo,
	nn: audioNormingNn,
};
class Intro extends React.Component {
	constructor(props) {
		super(props);
		this.audio = this.props.isNorming
			? audioObjNorming[strings.getLanguage()]
			: audioObj[strings.getLanguage()];

		this.ordforstaelseIntro = this.props.isNorming
			? strings.ordforstaelseIntroNorming
			: strings.ordforstaelseIntro;
		this.ordforstaelseTimelimit = this.props.isNorming
			? strings.ordforstaelseTimelimitNorming
			: strings.ordforstaelseTimelimit;
	}

	render() {
		const {onNextStep} = this.props;

		let videoRef;

		return (
			<div>
				<div
					className={
						this.props.isNorming ? 'text-center' : 'text-left'
					}
				>
					<p>
						<AudioPlayer
							autoplay
							inline
							onPause={() => {
								videoRef.play();
							}}
							src={this.audio}
							onErrorPlay={() => {
								console.log('Something went wrong');
							}}
						/>
						{this.ordforstaelseIntro}
					</p>
					<p>{this.ordforstaelseTimelimit}</p>
				</div>
				<div className="lit-preview">
					<p className="lit-preview__label">
						{strings.testLooksLikeThis}
					</p>
					<video
						className="lit-preview__video"
						loop
						ref={(ref) => {
							videoRef = ref;
						}}
						src={tutorialVideo}
					/>
				</div>
				<button
					className="lit-btn bg-primary"
					onClick={() => onNextStep()}
				>
					{strings.start}
				</button>
			</div>
		);
	}
}

const mapStateToProps = () => {
	return {};
};

export default connect(mapStateToProps)(Intro);
